import { type CSSProperties } from "react";

import css from "./slider.module.scss";

interface SliderProps {
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
  id?: string;
  leftLabel?: string;
  rightLabel?: string;
  step?: number;
}

export function Slider({
  value,
  min,
  max,
  onChange,
  id,
  leftLabel,
  rightLabel,
  step = 1,
}: SliderProps) {
  return (
    <div className={css.root}>
      <input
        className={css.input}
        id={id}
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={e => onChange(Number(e.target.value))}
        style={{
          ["--slider-value" as keyof CSSProperties]: `${((value - min) / (max - min)) * 100}%`,
        }}
        step={step}
      />
      <div className={css.labels}>
        {leftLabel && (
          <span className={`${css.label} ${css.left}`}>{leftLabel}</span>
        )}

        {rightLabel && (
          <span className={`${css.label} ${css.right}`}>{rightLabel}</span>
        )}
      </div>
    </div>
  );
}
